import { ProviderExtension } from "../registry";

export const twitterExtension: ProviderExtension = {
  labels: {
    webClientIdLabel: "Client ID",
    webClientIdPlaceholder: "abc123XyZ456def-789",
  },
};
